import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
	    { path: '/', component: require(page+'home.vue').default },
      { path: '/historia', component: require(page+'about-us/index.vue').default, meta:{title:"Historia"}},
      { path: '/galeria', component: require(page+'gallery/index.vue').default, meta:{title:"Galería"}},
      { path: '/mercado', component: require(page+'market/index.vue').default, meta:{title:"Mercado"}},
      { path: '/ventajas', component: require(page+'advantages/index.vue').default, meta:{title:"Ventajas"}},
	    { path: '/contacto', component: require(page+'contact/index.vue').default, meta:{title:"Contacto"}},

      { path: '/productos', component: require(page+'products/index.vue').default, meta:{title:"Productos"}},
      { path: '/productos/ps-seri', component: require(page+'products/ps-seri.vue').default, meta:{title:"PS-SERI"}},
      { path: '/productos/ps-off', component: require(page+'products/ps-off.vue').default, meta:{title:"PS-OFF"}},
      { path: '/productos/ps-ter', component: require(page+'products/ps-ter.vue').default, meta:{title:"PS-TER"}},
      { path: '/productos/ps-std', component: require(page+'products/ps-std.vue').default, meta:{title:"PS-STD"}},
      { path: '/productos/pp-imp', component: require(page+'products/pp-imp.vue').default, meta:{title:"PP-IMP"}},
      { path: '/productos/pp-grab', component: require(page+'products/pp-grab.vue').default, meta:{title:"PP-GRAB"}},
      { path: '/productos/tira', component: require(page+'products/tira.vue').default, meta:{title:"Tira"}},

	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "Procesos Plásticos Laminados S.A de C.V", filter: (title)=>{ return title+" - Procesos Plásticos Laminados S.A de C.V"; } }
);

// export {routes};
export default MyRouter;
